<div class="grid ">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_INSERIR_CANAL_DE_INDICACAO')">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card">
            <form #f="ngForm" name="form" novalidate (paste)="onPaste($event)" (drop)="onDrop($event)"
                (dragover)="onDragOver($event)">
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid mb-3">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                        </div>
                        <div class="field col-12 md:col-12">
                            <label htmlFor="descricao">Tipo de chamado</label>
                            <p-dropdown [options]="listaTipoChamado" optionLabel="label" optionValue="value"
                                placeholder="Selecione" name="tipo" ngModel #tipo="ngModel" [required]="true"
                                [(ngModel)]="tipoChamadoSelecionado" [required]="true">
                            </p-dropdown>
                            <div *ngIf="tipo.touched && tipo.hasError('required')" class="alerta">
								<small>Campo requerido</small>
							</div>
                        </div>
                        <div class="field col-12 md:col-12">
                            <label htmlFor="descricao">Descrição</label>
                            <textarea class="text-xl" id="description" type="text" pInputTextarea [rows]="8"
                                [(ngModel)]="textoDescricaoChamado" style="resize: none" name="descricao"
                                #descricao="ngModel" required></textarea>
                            <div *ngIf="descricao.touched && descricao.hasError('required')" class="alerta">
								<small>Campo requerido</small>
							</div>
                        </div>

                        <div class="col-12">

                            <div *ngIf="arquivosAnexados.length > 0"
                                class="flex flex-nowrap overflow-x-auto justify-start gap-3">
                                <div *ngFor="let arquivo of arquivosAnexados; let i = index"
                                    class="relative w-8rem h-8rem">

                                    <img *ngIf="arquivo.preview" [src]="arquivo.preview" [pTooltip]="arquivo.nome"
                                        class="object-cover w-full h-full rounded border-1 border-round border-gray-500" />
                                    <div *ngIf="arquivo.icone" [pTooltip]="arquivo.nome"
                                        class="flex align-items-center justify-content-center w-full h-full border-1 border-round border-gray-500">
                                        <i [ngClass]="arquivo.icone" class="text-4xl"></i>
                                    </div>
                                    <button pButton (click)="removerArquivo(i)" icon="pi pi-trash"
                                        class="p-button-danger absolute top-0 right-0 mt-1 mr-1 w-2rem h-2rem">
                                    </button>
                                </div>
                            </div>

                            <div
                                class="border-2 border-dashed border-gray-300 rounded-lg p-4 mt-2 text-center surface-100">
                                <i class="pi pi-upload text-4xl text-gray-500 mb-2 cursor-pointer"
                                    (click)="fileInput.click()"></i>
                                <p class="text-gray-700 font-medium cursor-pointer" (click)="fileInput.click()">Arraste
                                    e solte arquivos
                                    aqui ou cole com Ctrl+V</p>
                                <p class="text-xl text-gray-600">PNG, JPG, PDF, CSV, DOCX até 5MB</p>
                            </div>

                            <input #fileInput type="file"
                                accept="image/*, application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv"
                                multiple hidden (change)="onFileSelect($event)" />
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-between">
                        <div class="col-12 md:col-4">
                            <button *ngIf="!progressoRequisicao && !f.form.invalid else exibirBotaoFalso"
                                type="submit" pButton icon="pi pi-check" label="Abrir Chamado"
                                class="p-button-outlined p-button-success md:w-13rem"
                                [disabled]="!textoDescricaoChamado || arquivosProcessando > 0" (click)="criarChamado()">
                            </button>
                            <ng-template #exibirBotaoFalso>
                                <button type="submit" pButton
                                    [icon]="progressoRequisicao ? 'pi pi-spin pi-spinner':'pi pi-check'"
                                    label="Abrir Chamado" class="p-button-outlined p-button-success md:w-13rem"
                                    disabled>
                                </button>
                            </ng-template>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                class="p-button-outlined md:w-9rem" routerLink="/apps/suporte"></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>